// Shared helpers for offline-aware UI.

/**
 * True when a failed query/request is best explained by a lack of connectivity
 * rather than a real server error. Axios network failures have no `response`
 * (a 4xx/5xx does), and `navigator.onLine === false` is a direct signal. Used
 * to show a calm "you're offline" state instead of a red error box.
 */
export function isOfflineError(error) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true
  return !!error && !error.response
}
